import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import MuiTabs from "@mui/material/Tabs";
import { styled } from "@mui/material/styles";
import { styledOmitPropsOptions } from "../../theme/styled.helpers";

type TabBarAreaProps = {
    $hasSideContent: boolean;
};

type TabViewportProps = {
    $fixTabViewportWidth?: boolean;
};

export const TabsRoot = styled(Box)(({ theme }) =>
    theme.unstable_sx({
        width: "100%",
    }),
);

export const TabBarRow = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        flexDirection: "row",
        alignItems: "stretch",
        m: { md: 0, xs: -4 },
    }),
);

export const TabBarArea = styled(Box, styledOmitPropsOptions)<TabBarAreaProps>(({ theme, $hasSideContent }) =>
    theme.unstable_sx({
        backgroundColor: "transparent",
        borderBottom: 0,
        flex: "none",
        position: { md: "static", xs: "fixed" },
        zIndex: "drawer",
        width: { md: $hasSideContent ? "58.5%" : "100%", xs: "100%" },
        mt: -1,
        mr: { md: $hasSideContent ? 6 : 0 },
    }),
);

export const TabsViewport = styled(Box, styledOmitPropsOptions)<TabViewportProps>(({ theme, $fixTabViewportWidth }) =>
    theme.unstable_sx({
        width: { md: $fixTabViewportWidth ? "100%" : "calc(100% + 40px)", xs: "100%" },
        height: { md: 54, xs: 50 },
        overflow: "hidden",
        ml: { md: $fixTabViewportWidth ? 0 : -5, xs: 0 },
        mb: -3,
        px: { md: $fixTabViewportWidth ? 0 : 5, xs: 0 },
    }),
);

export const StyledTabs = styled(MuiTabs, styledOmitPropsOptions)<TabViewportProps>(({ theme, $fixTabViewportWidth }) =>
    theme.unstable_sx({
        width: $fixTabViewportWidth ? "100%" : undefined,
        backgroundColor: "white.main",
        boxShadow: "far",
        minHeight: 0,
        pointerEvents: "all",
        "& .MuiTab-root": {
            ...theme.typography.bodyTextS,
            [theme.breakpoints.up("md")]: theme.typography.bodyTextM,
            textTransform: "none",
            minWidth: 0,
            minHeight: 0,
            p: 3,
            mr: 3,
        },
        "& .MuiTab-root:first-of-type": {
            ml: 4,
        },
    }),
);

export const PanelsContainer = styled(Box)(({ theme }) =>
    theme.unstable_sx({
        pt: { md: 0, xs: 8 },
    }),
);

export const TabPanel = styled(Box, {
    shouldForwardProp: (prop) => prop !== "visible",
})<{ visible: boolean }>(({ visible }) => ({
    display: visible ? "block" : "none",
}));

export const TabPanelContent = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        gap: 6,
        p: 1,
        pt: { md: 7, xs: 1 },
        overflowX: "hidden",
    }),
);
